import fetchApi from "../backend/fetchApi";
import { usePlayer } from "../player/playerContext";

const useErrorReport = () => {

  const [player] = usePlayer() as any;

  return {
    reportError: async (title: string, message: string) => {
      const playerUrl = player && player._links.logError;
      if (!playerUrl) return;

      const res = await fetchApi(playerUrl.href, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          title: title,
          message: message
        })
      });

      let json = await res.json();

      json.success = res.ok;

      return json;
    },
  }
}

export default useErrorReport;